import { type Middleware } from 'swr'

/**
 * 情境
 * API key 開頭是 /campaigns/ 的時候，代表無此活動，不需要 retry
 */
export const withCampaignNotFound: Middleware = (useSWRNext) => {
  return (key, fetcher, config) => {
    const swr = useSWRNext(key, fetcher, {
      ...config,
      onErrorRetry: (error, key, swrConfig, revalidate, revalidateOpts) => {
        if (config.onErrorRetry) {
          return config.onErrorRetry(error, key, swrConfig, revalidate, revalidateOpts)
        }
        const isFetchCampaign = key.startsWith('/campaigns/')
        if (isFetchCampaign && error.response?.status === 404) {
          return
        }
      },
    })

    return {
      ...swr,
    }
  }
}
